export default __webpack_public_path__ + "static/media/convertidor.b9863930.jpg";